export default {
    message: {
        impersonation: "Je bestelt namens «{name}»"
    }
}